import { render } from "./DetailPropriete.vue?vue&type=template&id=01c50829&scoped=true"
import script from "./DetailPropriete.vue?vue&type=script&lang=js"
export * from "./DetailPropriete.vue?vue&type=script&lang=js"

import "./DetailPropriete.vue?vue&type=style&index=0&id=01c50829&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c50829"]])

export default __exports__